<template>
    <nav class="navbar navbar-expand-xxl navbar-light mx-0 px-5 py-0" v-if="showHeader">
        <router-link class="navbar-brand" :to="`/${instance}/start/`">
            <img src="https://static.ultralibrarian.com/images/logos/ul-logo-red.svg" style="height:40px;" />
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link class="nav-link" :to="`/${instance}/search/keyword/`">Search by Keyword</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="`/${instance}/search/pn/`">Search by Manufacturer</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="`/${instance}/reference/`">Search Reference Designs</router-link>
                </li>
            </ul>
            <ul v-if="oidcIsAuthenticated" class="navbar-nav">
                <li class="nav-item">
                    <router-link class="nav-link" :to="`/${instance}/profile`">Profile</router-link>
                </li>
                <li class="nav-item">
                    <a v-if="oidcIsAuthenticated" class="nav-link" href @click.prevent="signOut">Logout</a>
                </li>
            </ul>
            <ul v-if="!oidcIsAuthenticated" class="navbar-nav">
                <li class="nav-item">
                    <router-link class="nav-link" :to="`/${instance}/account/register`">Register</router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href @click.prevent="signIn">Login</a>
                </li>
            </ul>
        </div>
    </nav>
    <div class="text-danger" v-for="error of globalError" :key="error">
        {{ error }}
    </div>
    <router-view />
    <OffsitePanel></OffsitePanel>
</template>

<script>
    import $ from 'jquery'
    import { defineEmits } from 'vue'
    import { mapGetters, mapActions, mapState } from 'vuex'
    import OffsitePanel from '@/components/terms/OffsiteModal.vue'

    export default {
        name: 'Home',
        components: {
            OffsitePanel
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated',
                'oidcUser'
            ]),
            ...mapState({
                user: state => state.user,
                instance: state => state.instance,
                version: state => state.version,
                backLink: state => state.navigation.backLink,
                returnUrl: state => state.navigation.returnUrl,
                currentPanel: state => state.navigation.currentPanel,
                globalError: state => state.globalError
            }),
            hasAccess: function () {
                return this.oidcIsAuthenticated || this.$route.meta.isPublic
            },
            showHeader() {
                return this.$route.name != 'oidcCallback';
            },
            showHome: function () {
                return this.$route.name == 'Profile';
            },
            showProfile: function () {
                return this.$route.name != 'Profile';
            },
            v2Features: function () {
                return this.version >= 2
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc',
                'signOutOidcSilent'
            ]),
            goToStart: function () {
                this.$store.dispatch('goToStart');
            },
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                if (this.returnUrl)
                    this.authenticateOidc({ redirectPath: this.returnUrl, options: localOptions });
                else
                    this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            },
            signOut: function () {
                this.signOutOidcSilent();
                this.$store.commit('SIGN_OUT');
                this.$store.commit('CANCEL_EXPORT');
            },
            startup: async function () {
                await this.$router.isReady();
                this.$store.commit('SET_INSTANCE', this.$route.params.instance);
                this.$store.dispatch('siteLoaded');
                this.$store.dispatch('getProjectDropdown');

                if (!this.user.confirmed && this.oidcUser && !(this.oidcUser.role && (this.oidcUser.role == 'RegisteredUser' || this.oidcUser.role.includes('RegisteredUser')))) {
                    this.$router.push({ name: 'CompleteRegister' });
                }
            },
            search: function (mfr, text, type, page) {
                var mfrId = "";
                var searchTerm = "";
                if (typeof (mfr) != undefined && mfr && mfr != null) {
                    mfrId = mfr;
                }
                if (typeof (text) != undefined && text && text != null) {
                    searchTerm = text;
                }

                this.$store.commit('CLEAR_PART_NUMBER');
                this.$store.commit('SET_SEARCH_VALUES', { searchType: type, searchManufacturerId: mfrId, searchText: searchTerm, page: page });
                this.$store.commit('CHANGE_PANEL', 'search');
            },
            referenceSearch: function (mfrs, text, page) {
                var mfrIds = [];
                var searchTerm = "";
                if (typeof (mfrs) != undefined && mfrs && mfrs != null) {
                    mfrIds = mfrs.split(",");
                }
                if (typeof (text) != undefined && text && text != null) {
                    searchTerm = text;
                }
                this.$store.commit('SET_REFERENCE_VALUES', { selectedMfrIds: mfrIds, searchText: searchTerm, page: page });
                this.$store.commit('CHANGE_PANEL', 'reference');
            },
            searchtype: function (type) {
                this.$store.commit('CHANGE_SEARCH_TYPE', type);
                this.$store.commit('CHANGE_PANEL', 'search'); 
            },
            homesearch: function () {
                this.$store.commit('CHANGE_PANEL', 'search');
            },
            offSiteUrl: function (url) {
                this.$store.dispatch('openUrl', { url: url });
            }
        },
        created() {
        },
        mounted() {
            this.startup();
            //hack to deal with hard coded href targeting _blank in a browser that does not support opening other windows.
            //Pops up the target url in a local iframe as a modal
            $('body').on('click', 'a', (e) => {
                if (e.target.target == "_blank") {
                    e.preventDefault();
                    this.offSiteUrl(e.target.href);
                }
            });
            document.body.classList.add('frut-45-light');
            this.clearunsub = this.$store.subscribeAction({
                before: () => {
                    this.$store.commit('CLEAR_GLOBAL_ERROR');
                }
            }, { prepend: true });
        },
        beforeUnmount() {
            this.clearunsub();
            document.body.classList.remove('frut-45-light');
        },
        watch: {
            $route: async function (to, from) {

                await this.$router.isReady();
                //hack to prevent unrelated changes from causing re-loading of a current page
                if (to.path != from.path) {
                    var mfr;
                    var mfrs;
                    var text;
                    var type = 'external';
                    var page = 1;

                    //collapse menu header
                    $('#navbarSupportedContent').collapse('hide')

                    if (this.$route.params.page)
                        page = this.$route.params.page;

                    switch (from.name) {
                        case "KeySearch":
                        case "KeyDefSearch":
                        case "MfrPnSearch":
                        case "MfrPnDefSearch":
                        case "TextPnSearch":
                        case "FullPnSearch":
                            if (from.fullPath) {
                                this.$store.commit('SET_SEARCH_BACKLINK', from.fullPath);
                                this.$store.commit('SET_BACKLINK', from.fullPath);
                            }
                            break;
                        case "CompatiblePart":
                        case "CompetitivePart":
                        case "Part":
                        case "ReferPart":
                        case "MatchPart":
                        case "MatchReferPart":
                        case "ExternalPart":
                            if (from.fullPath) {
                                this.$store.commit('SET_BACKLINK', from.fullPath);
                            }
                            break;
                    }

                    switch (to.name) {
                        case "Part":
                        case "ReferPart":
                        case "MatchPart":
                        case "MatchReferPart":
                        case "ExternalPart":
                            await this.$store.dispatch('selectPart', { puid: this.$route.params.partuuid, euid: this.$route.params.euid });
                            await this.$store.dispatch('getActiveLibrary');
                            await this.$store.dispatch('refreshProfile');
                            break;
                        case "Search":
                            this.homesearch();
                            break;
                        case "KeySearch":
                            this.searchtype(type);
                            break;
                        case "KeyDefSearch":
                            text = this.$route.params.searchtext;
                            this.search(mfr, text, type, page);
                            break;
                        case "ReferenceBase":
                            await this.$store.dispatch('refreshProfile');
                            this.referenceSearch(null, null, 1);
                            break;
                        case "ReferencPage":
                            await this.$store.dispatch('refreshProfile');
                            this.referenceSearch(null, null, page);
                            break;
                        case "ReferenceSearch":
                            text = this.$route.params.referencetext;
                            await this.$store.dispatch('refreshProfile');
                            this.referenceSearch(null, text, page);
                            break;
                        case "ReferenceMfrPage":
                            await this.$store.dispatch('refreshProfile');
                            mfrs = this.$route.params.searchmanufacturers;
                            await this.$store.dispatch('refreshProfile');
                            this.referenceSearch(mfrs, null, page);
                            break;
                        case "ReferenceMfrSearch":
                            await this.$store.dispatch('refreshProfile');
                            mfrs = this.$route.params.searchmanufacturers;
                            text = this.$route.params.referencetext;
                            this.referenceSearch(mfrs, text, page);
                            break;
                        case "MfrPnSearch":
                            type = 'internal';
                            this.searchtype(type);
                            break;
                        case "MfrPnDefSearch":
                            mfr = this.$route.params.searchmanufacturer;
                            type = 'internal';
                            this.search(mfr, text, type, page);
                            break;
                        case "TextPnSearch":
                            text = this.$route.params.searchtext;
                            type = 'internal';
                            this.search(mfr, text, type, page);
                            break;
                        case "FullPnSearch":
                            mfr = this.$route.params.searchmanufacturer;
                            text = this.$route.params.searchtext;
                            type = 'internal';
                            this.search(mfr, text, type, page);
                            break;
                        case 'Start':
                            this.goToStart();
                            await this.$store.dispatch('getActiveLibrary');
                            break;
                    }
                }
            },
            '$route.params.instance': async function() {
                await this.$router.isReady();
                this.$store.commit('SET_INSTANCE', this.$route.params.instance);
            }
        }
    };
</script>

<style scoped>
    .nav-link {
        padding: 15px;
    }

    a.nav-link {
        font-size: 15px;
        color: black !important;
    }

    .nav-link:focus, .nav-link:hover {
        text-decoration: none;
        background-color: #eee;
    }

    .navbar {
        border-bottom: var(--ul-red) 2px solid;
        background-color: white;
    }
    @media (min-width: 1300px) {
        .navbar-expand-xxl {
            -ms-flex-flow: row nowrap;
            flex-flow: row nowrap;
            -ms-flex-pack: start;
            justify-content: flex-start;
        }

            .navbar-expand-xxl .navbar-nav {
                -ms-flex-direction: row;
                flex-direction: row;
            }

                .navbar-expand-xxl .navbar-nav .dropdown-menu {
                    position: absolute;
                }

                .navbar-expand-xxl .navbar-nav .nav-link {
                    padding-right: 0.5rem;
                    padding-left: 0.5rem;
                }

            .navbar-expand-xxl > .container,
            .navbar-expand-xxl > .container-fluid, .navbar-expand-xxl > .container-sm, .navbar-expand-xxl > .container-md, .navbar-expand-xxl > .container-lg, .navbar-expand-xxl > .container-xl {
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }

            .navbar-expand-xxl .navbar-nav-scroll {
                overflow: visible;
            }

            .navbar-expand-xxl .navbar-collapse {
                display: -ms-flexbox !important;
                display: flex !important;
                -ms-flex-preferred-size: auto;
                flex-basis: auto;
            }

            .navbar-expand-xxl .navbar-toggler {
                display: none;
            }
    }

    @media (max-width: 1299.98px) {
        .navbar-expand-xxl > .container,
        .navbar-expand-xxl > .container-fluid, .navbar-expand-xxl > .container-sm, .navbar-expand-xxl > .container-md, .navbar-expand-xxl > .container-lg, .navbar-expand-xxl > .container-xl {
            padding-right: 0;
            padding-left: 0;
        }
    }
</style>